import { Container, Header } from "components/Page"

import BillingTypes from "./List"
import Breadcrumbs from "components/Breadcrumbs"
import CopyQualities from "./List/CopyQualities"
import CreativeAgencies from "./List/CreativeAgencies"
import { EnableOxygenToggle } from "./EnableOxygenToggle"
import { EnablePostingToIsapToggle } from "./EnablePostingToIsapToggle"
import { EnablePreEvalToggle } from "./EnablePreEvalToggle"
import { FetchRankingsToggle } from "./FetchRankingsToggle"
import { SubBillingTypesModal } from "../components/AddNewSubBillingType"
import { Surface } from "components/Surface"
import TargetParameters from "./List/TargetParameters"
import { TimeZone } from "./List/TimeZone"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"
import { EnableDigitalExportToggle } from "./EnableDigitalExportToggle"
import { EnablePostEvalToggle } from "./EnablePostEvalToggle"
import { EnableCrudProductsToggle } from "./EnableCrudProductsToggle"
import { MaxSpotMatchingTolerance } from "./MaxSpotMatchingTolerance"

function MarketSettings() {
  const { t } = useI18n()
  const { hasAuthority } = useAuthenticated()

  return (
    <Container>
      <Breadcrumbs
        section={t("nav.admin")}
        current={t("nav.market.settings")}
      />
      <Header label={t("nav.market.settings")}></Header>
      <Surface>
        <TimeZone />
        <FetchRankingsToggle />
        <EnableOxygenToggle />
        <EnablePreEvalToggle />
        <EnablePostingToIsapToggle />
        <EnableDigitalExportToggle />
        <EnablePostEvalToggle />
        <EnableCrudProductsToggle />
        <MaxSpotMatchingTolerance />
        <BillingTypes />
        <SubBillingTypesModal />
        {hasAuthority(["AUTH_VIEW_TARGET_PARAMETER"]) && <TargetParameters />}
        {hasAuthority(["AUTH_VIEW_CREATIVE_AGENCY"]) && <CreativeAgencies />}
        {hasAuthority(["AUTH_VIEW_COPY_QUALITY"]) && <CopyQualities />}
      </Surface>
    </Container>
  )
}

export default MarketSettings
